import type { YachtViewerState } from "@cloudnest/yacht-engine";
import { useState } from "react";

export function GameResultPanel({
  state,
  onLeaveGame,
}: {
  readonly state: YachtViewerState;
  readonly onLeaveGame: () => void;
}) {
  const [closed, setClosed] = useState(false);

  if (state.phase !== "GAME_OVER" || !state.rankings) return null;
  if (closed) return null;

  return (
    <div className="yacht-result-overlay" data-testid="yacht-result-modal">
      <section className="yacht-result-panel">
        <header className="yacht-result-header">
          <strong>순위</strong>
          <button
            aria-label="순위 모달 닫기"
            className="yacht-result-close"
            data-testid="yacht-result-close-button"
            onClick={() => setClosed(true)}
            type="button"
          >
            X
          </button>
        </header>
        <div className="yacht-result-list">
          {state.rankings.map((ranking) => {
            const player = state.players.find(
              (candidate) => candidate.playerId === ranking.playerId,
            );
            return (
              <div
                className="yacht-result-row"
                data-rank={ranking.rank}
                key={ranking.playerId}
              >
                <span>{ranking.rank}</span>
                <strong>{player?.displayName ?? ranking.playerId}</strong>
                <span>{ranking.total}</span>
              </div>
            );
          })}
        </div>
        <button
          className="yacht-button primary"
          data-testid="yacht-result-lobby-button"
          onClick={onLeaveGame}
          type="button"
        >
          로비로 돌아가기
        </button>
      </section>
    </div>
  );
}
